import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["content", "submitBtnText", "secondaryBtnText", "title", "isVisible"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';

// Components
import Modal from '../Modal';
var ConfirmationDialog = /*#__PURE__*/function (_Component) {
  _inherits(ConfirmationDialog, _Component);
  var _super = _createSuper(ConfirmationDialog);
  function ConfirmationDialog() {
    var _this;
    _classCallCheck(this, ConfirmationDialog);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleDialogClose", function () {
      var onCancel = _this.props.onCancel;
      onCancel();
    });
    _defineProperty(_assertThisInitialized(_this), "handleDialogSubmit", function () {
      var onSubmit = _this.props.onSubmit;
      onSubmit();
    });
    return _this;
  }
  _createClass(ConfirmationDialog, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        content = _this$props.content,
        submitBtnText = _this$props.submitBtnText,
        secondaryBtnText = _this$props.secondaryBtnText,
        title = _this$props.title,
        isVisible = _this$props.isVisible,
        rest = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/React.createElement(Modal, _extends({}, rest, {
        content: content,
        onCancel: this.handleDialogClose,
        onSubmit: this.handleDialogSubmit,
        submitBtnText: submitBtnText,
        secondaryBtnText: secondaryBtnText,
        title: title,
        visible: isVisible
      }));
    }
  }]);
  return ConfirmationDialog;
}(Component);
ConfirmationDialog.propTypes = {
  title: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  submitBtnText: PropTypes.string,
  secondaryBtnText: PropTypes.string,
  isVisible: PropTypes.bool
};
ConfirmationDialog.defaultProps = {
  title: __('Confirmation Dialog'),
  content: __('Are you sure ?'),
  onSubmit: _noop,
  onCancel: _noop,
  submitBtnText: __('Yes'),
  secondaryBtnText: __('No'),
  isVisible: false
};
export default ConfirmationDialog;